import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { formatDate } from 'utils/date';

interface ITrustedDeviceTableCard {
  data: ITableDataSource;
  longDateFormat: string;
}

export const TrustedDeviceTableCard = ({ data, longDateFormat }: ITrustedDeviceTableCard) => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid
        size={{
          xs: 6,
          lg: 3,
        }}
        sx={{
          px: 2,
          pt: 2,
        }}
      >
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          Trusted Device
        </Typography>
        <Typography variant="body2">
          {data.title}, {data.createdDate ? formatDate(data.createdDate, longDateFormat) : ''}
        </Typography>
      </Grid>

      <Grid
        container
        size={{ xs: 12 }}
        sx={{
          pt: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: {
            xs: `1px solid ${colors.primary25}`,
            lg: 'none',
          },
          m: {
            xs: 2,
            lg: 2,
          },
        }}
      >
        <Grid size={{ xs: 12, sm: 'auto' }}>
          <Typography
            variant="button"
            sx={{
              textTransform: 'uppercase',
            }}
          >
            Actions:{' '}
          </Typography>
        </Grid>
        <Grid
          container
          sx={{ mt: 1, rowGap: 1, justifyContent: 'right' }}
          size={{ xs: 12, sm: 'auto' }}
        >
          <Grid size={{ xs: 12, sm: 'auto' }}>
            <Button
              label="Remove"
              variant={EButtonVariants.outlined}
              onClick={() =>
                navigate(ERouteLinks.AccountRemoveDevice.replace(':id', data.id as string))
              }
              size="small"
              fullWidth
              sx={{ minWidth: { sm: '120px' } }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
